import { render, staticRenderFns } from "./Topup-Dialog.vue?vue&type=template&id=0f3a4ff8&scoped=true&"
import script from "./Topup-Dialog.vue?vue&type=script&lang=js&"
export * from "./Topup-Dialog.vue?vue&type=script&lang=js&"
import style0 from "./Topup-Dialog.vue?vue&type=style&index=0&id=0f3a4ff8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3a4ff8",
  null
  
)

export default component.exports